import { render } from "./ExhibitionDetails.vue?vue&type=template&id=dabd970c"
import script from "./ExhibitionDetails.vue?vue&type=script&lang=js"
export * from "./ExhibitionDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__